import { AiFillAppstore } from 'react-icons/ai';
import { FaMobile, FaGlobe } from 'react-icons/fa';
import { SiProgress, SiAntdesign, SiNpm } from 'react-icons/si';
import { CgWebsite } from 'react-icons/cg';
// Features Data
export const featuresData = [
    {
        id: 1,
        icon: <CgWebsite />,
        title: 'Web Development',
        des: 'I am a versatile web developer proficient in both front-end and back-end technologies. With expertise in HTML, CSS, JavaScript, and server-side programming languages, I design and implement dynamic and responsive websites. Committed to security and performance optimization, I deliver robust and innovative web solutions.',
    },
    {
        id: 2,
        icon: <AiFillAppstore />,
        title: 'App Development',
        des: 'App development is a dynamic and iterative process that requires creativity, technical expertise, and attention to detail. As a software engineer, i apply my programming skills, problem-solving abilities, and knowledge of software development principles to create functional and user-friendly applications.',
    },
    {
        id: 3,
        icon: <SiNpm />, // You can use the NPM icon from react-icons (e.g., SiNpm from react-icons/si)
        title: 'NPM Package Development',
        des: 'I create reusable and well-documented NPM packages for shared functionality across projects. With experience in module bundling, semantic versioning, and publishing workflows, I ensure that each package is optimized, maintainable, and easy to integrate into various codebases.',
    },
    {
        id: 4,
        icon: <FaMobile />,
        title: 'Mobile Development',
        des: 'Mobile development requires continuous learning and staying updated with the latest technologies and trends in the mobile industry. This includes adopting new programming languages, frameworks, and tools to deliver efficient, secure, and high-quality mobile applications.',
    },
    {
        id: 5,
        icon: <SiAntdesign />,
        title: 'APIs Development',
        des: ' API development with Node.js, Express, MongoDB, and SQL involves leveraging these technologies to build a robust server-side application that handles incoming requests, interacts with databases, and provides data and functionality to client applications through a well-defined API interface.',
    },
    {
        id: 6,
        icon: <FaGlobe />,
        title: 'Hosting Websites',
        des: 'Hosting a website requires technical knowledge, attention to detail, and adherence to best practices. As a software engineer i apply my their expertise to ensure the website is accessible, secure, and and performs well for its intended audience by continuously Monitoring the performance, availiability and security.',
    },
];
